import { render, staticRenderFns } from "./FacebookMvp.vue?vue&type=template&id=59fb4be6&scoped=true&"
import script from "./FacebookMvp.vue?vue&type=script&lang=js&"
export * from "./FacebookMvp.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMvp.vue?vue&type=style&index=0&id=59fb4be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb4be6",
  null
  
)

export default component.exports